module.exports = __webpack_public_path__ + "img/9dd70c8.png";